<template>
  <div class="box-container">
    <div
      class="box"
      v-for="sport in getBookingsPerCategory"
      v-bind:key="sport.id"
    >
      <h4 class="sport-name">{{ sport.sport }}</h4>
      <br />

      <p class="p">Amount of games played</p>
      <br />
      <div class="values-div">
        <output class="count">{{ sport.bookings }}</output>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["timePeriod"],
  name: "sport",

  computed: {
    ...mapGetters(["getBookingsPerCategory"])
  }
};
</script>

<style scoped>
.box-container {
  width: 100%;
  display: flex;
  /* flex-direction:row; */
  justify-content: space-between;
  align-content: space-between;
}

.box {
  width: inherit;
  height: 204px;
  padding: 30px 18px 24px 30px;
  font-size: 18px;
}
.box * {
  background-color: #383838;
}
img {
  margin-left: 250px;
}
.sport-name {
  margin: 5px 0 0 0;
}
p {
  font-size: 14px;
  opacity: 0.7;
  color: #c3c3c3;
}
.count {
  font-size: 30px;
  float: left;
  /* margin:0 170px 0 0; */
}
.procent {
  /* align-items: left ; */
  float: right;
}
.icon {
  width: 2rem;
  height: 2rem;
}
.values-div {
  margin: 16px 0 0 0;
}

@media (min-width: 530px) {
  .box-container {
    flex-flow: row wrap;
  }
  .box-container > .box {
    flex: 0.5;
  }
}

@media (min-width: 768px) {
  .box-container {
    flex-flow: row nowrap;
  }
  .box-container > div {
    width: 25% !important;
  }
}
</style>
